import {
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  useTheme,
} from '@mui/material'
import style from './courseTab.module.css'
import { CheckCircleOutline, TimerOutlined } from '@mui/icons-material'
import DateFunctions from '../../../services/date_functions'
import TimerIcon from '@mui/icons-material/Timer'
import moment from 'moment'
import AssignmentIcon from '@mui/icons-material/Assignment'
import * as React from 'react'
import LoadingSkeletonComponent from '../../LoadingComponents/LoadingSkeletonComponent'
import {
  IQuizWithStudentAnswer,
  ITemporaryLocalQuizWithStudentAnswer,
} from '../../../interfaces/IQuiz'
import { viewTopicAssessmentDetailsFromDatabase } from '../../../services/shared-api-service/shared-api-service'
import { Quiz } from '../../../class/quiz'
import { AssessmentNamespace } from '../../../services/assessment_namespace'
import dynamic from 'next/dynamic'
import { IUserDetails, IUserType } from '../../../interfaces/user.interface'

const AssessmentViewReadOnlyButton = dynamic(
  () => import('../../Assessments/AssessmentView/AssessmentViewReadOnlyButton'),
  {
    ssr: false,
    loading: () => <div />,
  },
)

const AssessmentViewButton = dynamic(
  () => import('../../Assessments/AssessmentView/AssessmentViewButton'),
  {
    ssr: false,
    loading: () => <div />,
  },
)

export default function StudentCourseAssessment(props: {
  topic: any
  user_details: IUserDetails
  user_type: IUserType
  refreshTopics?: () => void
}) {
  const [quizLoading, setQuizLoading] = React.useState(false)
  const [quizDetails, setQuizDetails] = React.useState<
    ITemporaryLocalQuizWithStudentAnswer | undefined
  >(undefined)
  const theme = useTheme()

  React.useEffect(() => {
    initQuizDetails()
  }, [props.topic._id])
  const initQuizDetails = async () => {
    const course_id = props.topic.course_id
    const course_content_id = props.topic._id

    setQuizLoading(true)

    try {
      const axiosRes = await viewTopicAssessmentDetailsFromDatabase(
        props.topic._id,
      )
      console.log('assessment #HERE#', axiosRes)
      setQuizLoading(false)
      if (!axiosRes || !axiosRes.data) {
        console.log('no quiz with this id')
        return
      }

      const data = axiosRes.data.data
      const newQuiz: ITemporaryLocalQuizWithStudentAnswer = new Quiz(
        data.name,
        data.note_before,
        data.note_after,
        data.published,
        data.questions,
        data.course_id || course_id,
        data.course_content_id || course_content_id,
        data.deadline,
        data.time_limit,
        data.no_of_tries,
        data.show_result,
        data.created_at,
        data.enable_accessible_on_homepage,
      )

      setQuizLoading(false)
      setQuizDetails(newQuiz)
      fillInStudentAnswer(data)
    } catch (e) {
      setQuizLoading(false)
    }
  }
  const fillInStudentAnswer = (quizDetailsArg: IQuizWithStudentAnswer) => {
    console.log('searching for answers')
    const _quizDetailsTemp: IQuizWithStudentAnswer = { ...quizDetailsArg }
    const questions = _quizDetailsTemp.questions
    const studentAnswer = _quizDetailsTemp.studentAnswer
      ? _quizDetailsTemp.studentAnswer.questions_result
      : null
    console.log('questions', questions)
    console.log('student answer', studentAnswer)
    if (!questions || !studentAnswer) {
      return
    }

    questions.map((question: any) => {
      for (let i = 0; i < studentAnswer.length; i++) {
        if (question._id === studentAnswer[i]._id) {
          console.log('answer found')
          question.userAnswer = studentAnswer[i].userAnswer
          question.checkedAnswers = studentAnswer[i].checkedAnswers
          question.answer_file_url = studentAnswer[i].answer_file_url
        }
      }
    })
    console.log('set', _quizDetailsTemp)
    setQuizDetails(_quizDetailsTemp)
  }
  const trialExhausted = () => {
    if (quizDetails?.no_of_tries === -1) {
      return false
    }
    return (
      quizDetails?.studentAnswer &&
      quizDetails.studentAnswer.no_of_tries >= quizDetails.no_of_tries
    )
  }
  const user_autogenerated_score_obj = AssessmentNamespace.getScoreBasedObjectiveCheckBoxTypeQuestion(
    quizDetails?.studentAnswer,
  )

  if (quizLoading) {
    return (
      <div>
        <LoadingSkeletonComponent />
      </div>
    )
  }

  return (
    <div>
      <Paper variant="outlined" style={{ padding: '20px', border: 'none' }}>
        <div>
          <div className={style.tabWrapper}>
            <div
              style={{
                border: '1px solid #e8e8e8',
                borderRadius: '10px',
              }}
              className={style.box}
            >
              <div
                style={{
                  // background: theme.palette.primary.dark,
                  // background: `linear-gradient(to right, ${theme.palette.primary.dark}, ${theme.palette.warning.dark})`,
                  height: 'auto',
                  textAlign: 'center',
                  padding: '10px 10px',
                  borderRadius: '5px 5px 0px 0px',
                }}
              >
                <Typography
                  // style={{ color: theme.palette.primary.contrastText }}
                  variant="body1"
                >
                  {quizDetails?.note_before}
                </Typography>
              </div>

              <List dense={true} style={{ maxWidth: '400px', margin: 'auto' }}>
                <div style={{ textAlign: 'center' }}>
                  <img width={'200px'} src={'/static/img/asset_quiz.svg'} />
                </div>
                <ListItem>
                  <ListItemText>
                    <Typography
                      style={{ display: 'flex', justifyContent: 'center' }}
                      variant="body2"
                    >
                      <CheckCircleOutline
                        style={{
                          marginRight: '10px',
                          color: theme.palette.primary.main,
                        }}
                      />
                      <span style={{ marginRight: '10px', fontWeight: 'bold' }}>
                        {' '}
                        Number of submissions:{' '}
                      </span>
                      {quizDetails?.studentAnswer?.no_of_tries || 0}/
                      {quizDetails?.no_of_tries === -1
                        ? 'unlimited'
                        : quizDetails?.no_of_tries}
                    </Typography>
                  </ListItemText>
                </ListItem>
                {quizDetails?.deadline && (
                  <ListItem>
                    <ListItemText>
                      <Typography
                        style={{ display: 'flex', justifyContent: 'center' }}
                        variant="body2"
                      >
                        <TimerOutlined
                          style={{
                            marginRight: '10px',
                            color: theme.palette.primary.main,
                          }}
                        />
                        <span
                          style={{ marginRight: '10px', fontWeight: 'bold' }}
                        >
                          Deadline:
                        </span>{' '}
                        {DateFunctions.convertDateFromDBFormat(
                          quizDetails?.deadline,
                        )}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                )}
                {quizDetails?.time_limit && (
                  <ListItem>
                    <ListItemText>
                      <div>
                        <Typography
                          style={{ display: 'flex', justifyContent: 'center' }}
                          variant="body2"
                        >
                          <TimerIcon
                            style={{
                              marginRight: '10px',
                              color: theme.palette.primary.main,
                            }}
                          />{' '}
                          <span
                            style={{ marginRight: '10px', fontWeight: 'bold' }}
                          >
                            Time allocated:
                          </span>{' '}
                          {moment
                            .duration(
                              quizDetails?.time_limit as number,
                              'minutes',
                            )
                            .humanize()}
                        </Typography>
                      </div>
                    </ListItemText>
                  </ListItem>
                )}
                {quizDetails?.studentAnswer && (
                  <ListItem>
                    <ListItemText>
                      <div>
                        <Typography
                          style={{ display: 'flex', justifyContent: 'center' }}
                          variant="body2"
                        >
                          <AssignmentIcon
                            style={{
                              marginRight: '10px',
                              color: theme.palette.primary.main,
                            }}
                          />{' '}
                          <span
                            style={{ marginRight: '10px', fontWeight: 'bold' }}
                          >
                            {' '}
                            {quizDetails?.studentAnswer?.score
                              ? 'Result:'
                              : 'Provisional Result (based on objective):'}
                          </span>{' '}
                          {Number(
                            quizDetails?.studentAnswer.score ||
                              user_autogenerated_score_obj.score,
                          ).toFixed(2)}
                          %
                        </Typography>
                      </div>
                    </ListItemText>
                  </ListItem>
                )}
              </List>
            </div>
          </div>
        </div>
        <div className={style.timedQuizTextContainer}>
          {quizDetails?.time_limit && (
            <Typography
              variant="body2"
              style={{ textAlign: 'center', margin: 'auto' }}
              className={style.timedQuizText}
            >
              This is a timed quiz. Once you start, you can't pause the timer.
              Your answers will be automatically submitted when the time is up.
            </Typography>
          )}
          <div
            className={style.tab_btns}
            style={{ justifyContent: 'center', marginTop: '5px' }}
          >
            <div
              style={{
                display: trialExhausted() ? 'none' : 'block',
              }}
            >
              <AssessmentViewButton
                buttonDisableElevation={true}
                onSubmitAssessment={() => {
                  console.log('Assessment submitted')
                  props.refreshTopics?.()
                }}
                topic={props.topic}
                buttonText={
                  quizDetails?.studentAnswer?.no_of_tries == undefined ||
                  quizDetails?.studentAnswer?.no_of_tries < 1
                    ? 'Start'
                    : 'Retry quiz'
                }
                user_details={props.user_details}
                user_type={props.user_type}
                buttonSize={'large'}
                view={'questions'}
                buttonStyle={{
                  margin: 'auto',
                  // marginRight: '5px',
                  // width: "110px",
                }}
              />
            </div>

            {/* show result button */}
            {quizDetails?.no_of_tries &&
              quizDetails?.no_of_tries > 0 &&
              quizDetails?.studentAnswer?.score &&
              quizDetails?.show_result === true && (
                <div
                  style={{
                    display:
                      quizDetails?.show_result === true ||
                      quizDetails?.studentAnswer?.score !== undefined
                        ? 'block'
                        : 'none',
                  }}
                >
                  <AssessmentViewReadOnlyButton
                    topic={props.topic}
                    buttonText={'Show result'}
                    user_details={props.user_details}
                    user_type={props.user_type}
                    variant={'outlined'}
                    buttonStyle={
                      {
                        // width: "110px",
                      }
                    }
                    buttonSize={'large'}
                  />
                </div>
              )}
          </div>
        </div>
      </Paper>
    </div>
  )
}
